import React from "react";
import CompanyList from "./components/CompanyList";


function App() {
  return (
    <div className="App">
      <CompanyList />
    </div>
  );
}

export default App;
